import React from 'react';

const ReadOnlyField = ({ value, unit, label = null }) => (
    <div className={'readonly-field'}>
        {label && <span>{label}</span>}
        <span>{value || 'N/A'} {unit}</span>
    </div>
);

export default ReadOnlyField;